const defaultConfig = require("./config.default.js");

module.exports = {
  ...defaultConfig,

  projectName: "Springwood",

  webfeedDebuggerWebsiteUrl:
    "https://myspringwood.com.au/now-selling/#/masterplan",
  webfeedConfig: {
    mode: "masterplan", // masterplan, feed
    type: "land" // land, packages, dwellings etc
  }
  // add other conf items below if needed
};
